'use client';

import { useSearchParams } from 'next/navigation';
import { FC, ReactNode, useEffect, useMemo, useState } from 'react';

import { TabsContext } from './tabs.context';

export interface TabsProviderProps {
  defaultActiveTabId: string;
  children: ReactNode;
  persist?: boolean;
}

export const TABS_PERSIST_KEY = '_t';

export const TabsProvider: FC<TabsProviderProps> = ({
  defaultActiveTabId,
  persist,
  children,
}) => {
  const syncedParam = useSearchParams()?.get('_t') || defaultActiveTabId;
  const [activeTabId, setActiveTabId] = useState(syncedParam);

  useEffect(() => {
    if (persist) {
      const params = new URLSearchParams(window.location.search);
      params.set(TABS_PERSIST_KEY, activeTabId);
      window.history.pushState(null, '', `?${params.toString()}`);
    }
  }, [activeTabId, persist]);

  return (
    <TabsContext.Provider
      value={useMemo(
        () => ({
          activeTabId,
          setActiveTabId,
          persist,
        }),
        [activeTabId, setActiveTabId, persist]
      )}
    >
      {children}
    </TabsContext.Provider>
  );
};
